import { workspaceSignatureRequestUrl } from '../urls';
import refresh from '../refresh';

export default async function postWorkspaceSignatureRequest(workspaceId, message) {
  const data = {
    workspace: workspaceId,
    message,
  };
  return refresh(async () => {
    const response = await fetch(workspaceSignatureRequestUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      body: JSON.stringify(data),
    });
    return response;
  });
}
